export enum NotificationToken {
  EXPO = 'EXPO',
  FIREBASE = 'FIREBASE',
}
